import { bucketApi } from "@/lib/axios";
import type { ApiResponse, CaptainHookVersion } from "../types/captainHook.types";

/** 최신 CaptainHook 버전 정보 조회. */
export const getCaptainHookVersion = async (): Promise<CaptainHookVersion> => {
  const { data } = await bucketApi.get<ApiResponse<CaptainHookVersion>>(
    "/api/captain-hook/version",
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

/**
 * 설치 파일 다운로드 엔드포인트 URL.
 *
 * 백엔드가 S3 presigned URL 로 302 redirect 하므로 anchor/새 탭으로 바로 연다.
 * bucketApi.baseURL 은 프로덕션에서만 채워지고(dev 는 "" → vite /api 프록시),
 * 그 규칙을 그대로 따른다.
 */
export const getCaptainHookDownloadUrl = (): string => {
  const base = bucketApi.defaults.baseURL ?? "";
  return `${base}/api/captain-hook/download`;
};
